import classNames from 'classnames';
import React from 'react';

import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { ToastVariant } from 'const';
import { formatJsonText } from 'utils/formatJsonText';
import { intlGet } from 'utils/intlGet';
import { IconColor } from '../Icon/models';
import { ToastProps } from './models';
import styles from './styles.module.scss';

const Toast: React.FunctionComponent<ToastProps> = ({ closeToast, title, message, type, link, linkText }) => {
  let defaultTitle = intlGet('Notification', 'Success');
  let iconColor: IconColor = 'success';
  let iconType = IconType.CHECK_MARK;

  if (type === ToastVariant.ERROR) {
    defaultTitle = intlGet('Notification', 'Error');
    iconType = IconType.CLOSE_BOLD;
    iconColor = 'error';
  }

  if (type === ToastVariant.WARNING) {
    defaultTitle = intlGet('Notification', 'Warning');
    iconType = IconType.EXCLAMATION_MARK;
    iconColor = 'primary';
  }
  if (type === ToastVariant.LOADING) {
    defaultTitle = intlGet('Notification', 'Loading');
    iconType = IconType.CIRCLE_SPINNER;
    iconColor = 'primary';
  }

  return (
    <div
      className={classNames(styles.Toast, {
        [styles.ToastSuccess]: type === ToastVariant.SUCCESS,
        [styles.ToastError]: type === ToastVariant.ERROR,
        [styles.ToastWarning]: type === ToastVariant.WARNING,
        [styles.ToastLoading]: type === ToastVariant.LOADING,
      })}
    >
      <div className={styles.icon}>
        <Icon type={iconType} size='badge-sm' color={iconColor} />
      </div>
      <div className={styles.messageContainer}>
        <div className={styles.messageTitle}>
          {title || defaultTitle}
          <div className={styles.closeIcon}>
            <Icon onClick={closeToast} type={IconType.CLOSE} size="auto" color="light-grey" />
          </div>
        </div>
        <div className={styles.messageDescription}>
          {formatJsonText(message)}
          {link && <a href={link} target='_blank' className={styles.messageLink}>{linkText || link}</a>}
        </div>
      </div>

    </div>
  );
};

export default Toast;
